import { AdminLandingPageView } from './AdminLandingPageView';

export function AdminLandingPageContainer() {
  return <AdminLandingPageView title="Admin dashboard" />;
}
